import React from "react";
import {Navigate, useRoutes} from "react-router-dom";
import {reachUrls} from "../layout/menu-items";
import {reachRoutes} from "./reachRoutes";

export default function Router() {
  return useRoutes([
    ...reachRoutes,
    {path: "*", element: <Navigate to={reachUrls.dashboard} replace />},
  ]);
}
